<template>
  <div id="app">
<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
import { initializeApp } from "firebase/app";
import { getAnalytics, logEvent } from "firebase/analytics";

export default {
  name: 'App',
  mounted() {
    const firebaseConfig = {
      apiKey: "AIzaSyAGqxjldnjQ2RVIBvkshjSZ6yxWS_U48oM",
      authDomain: "wcam-27caf.firebaseapp.com",
      projectId: "wcam-27caf",
      storageBucket: "wcam-27caf.appspot.com",
      messagingSenderId: "416171291529",
      appId: "1:416171291529:web:a4e4b85c5769fa3a466758",
      measurementId: "G-DL59JMSVBB"
    };

    window.fireBaseApp = initializeApp(firebaseConfig);
    const analytics = getAnalytics()
    logEvent(analytics, 'app_initialized')
  }
}
</script>

<style>
body {
  padding: 0;margin: 0
}
.score-boards {

}
@media (max-aspect-ratio: 1/1) {
  .score-boards {
    text-align: right;
  }
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width: 100vw;
  overflow-x: hidden;
}
div.contents {

}
.noto300 {
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 300;
}
.noto400 {
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 400;
}
.noto500 {
  font-family: 'Noto Sans JP', sans-serif;
  font-weight: 500;
  /*font-family: 'DotGothic16', sans-serif;*/
}
</style>



// WEBPACK FOOTER //
// src/App.vue